var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkBtnPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 63.4",
    style: {
      enableBackground: "new 0 0 56.3 63.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#664BAF;}\r\n\t.st1{fill:#805AD5;}\r\n\t.st2{fill:#9579E2;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 107,
    height: 59,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHRAAACLgAAAuz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADwAawMBIgACEQEDEQH/ xAB/AAEBAQEBAAAAAAAAAAAAAAAAAwUGBwEBAQEAAAAAAAAAAAAAAAAAAAIFEAACAQUAAwEAAAAA AAAAAAAABRQBEQMVFiAwQFARAAEBCQEBAQAAAAAAAAAAAAADMdECkqLSM5MENEBQEgADAAMAAAAA AAAAAAAAAAAAMaIgMED/2gAMAwEAAhEDEQAAAPQAAAAAAAc8wmhe6whusIbrCG6whusIbrCHbrs+ ILiC4guILiC4guAAAAAAAP/aAAgBAgABBQDzj4CPgI+Aj4CPgI+Aj4Pf/9oACAEDAAEFAPO1C1C1 C1C1C1C1Pf8A/9oACAEBAAEFAPs6FcdCuOhXHQrjoVx0K46FcdCuOhXHQrjoVx0K46FcdCuNaxNa xNaxNaxNaxNaxNaxNaxNaxNaxNaxNaxNaxNaxIxGIxGIxGIxGIxGIxGIxG/L/9oACAECAgY/AM3Q 6HQ6HQ6HW/8A/9oACAEDAgY/AOz/2gAIAQEBBj8A+xvXTcN66bhvXTcN66bhvXTcN66bhvXTcN66 bhvXTcN66bhvXTcN66bhvXTcN66bjyra4nHlW1xOPKtriceVbXE48q2uJx5VtcTjyra4nHlW1xOP KtriceVbXE48q2uJx5VtcTjyra4nHlW1xOMqkxlUmMqkxlUmMqkxlUmMqkxlUmMqkxlUmMqkxlUm MqkxlUm/L//Z",
    transform: "matrix(1 0 0 1 -7894 -7770.1099)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st0",
    d: "M43.1,7.1H11.5C5.1,7.1,0,12.2,0,18.6v33.3c0,6.3,5.1,11.5,11.5,11.5h33.3 c6.3,0,11.5-5.1,11.5-11.5V20.2C56.3,13,50.4,7.1,43.1,7.1L43.1,7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st1",
    d: "M47.4,52.3H8.9c-2.7,0-4.8-2.2-4.8-4.8V8.9c0-2.7,2.2-4.8,4.8-4.8h38.5c2.7,0,4.8,2.2,4.8,4.8 v38.5C52.3,50.1,50.1,52.3,47.4,52.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st2",
    d: "M43.1,6c3.9,0,7.2,3.2,7.2,7.2v32.3c0,2.7-2.2,4.8-4.8,4.8H10.8c-2.7,0-4.8-2.2-4.8-4.8V10.8 C6,8.2,8.2,6,10.8,6H43.1 M43.1,0H10.8C4.8,0,0,4.8,0,10.8v34.7c0,6,4.8,10.8,10.8,10.8h34.7c6,0,10.8-4.8,10.8-10.8V13.2 C56.3,5.9,50.4,0,43.1,0L43.1,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st3",
    d: "M42.1,22.6L27.3,37.4c-0.5,0.5-1.3,0.5-1.8,0l-2-2c-0.5-0.5-0.5-1.3,0-1.8l14.8-14.8 c0.5-0.5,1.3-0.5,1.8,0l2,2C42.6,21.3,42.6,22.1,42.1,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st3",
    d: "M21.3,25.5l6.7,6.7c0.5,0.5,0.5,1.3,0,1.8l-2,2c-0.5,0.5-1.3,0.5-1.8,0l-6.7-6.7 c-0.5-0.5-0.5-1.3,0-1.8l2-2C20,25,20.8,25,21.3,25.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkBtnPurple);
export default __webpack_public_path__ + "static/media/ok_btn_purple.f71096584dc4273901f41e53a99d4834.svg";
export { ForwardRef as ReactComponent };